export default "__VITE_ASSET__DhOsTkxP__"